import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfilComponent } from '../profil/profil.component';
import { UserAlarmAccidentComponent } from './user-alarm-accident/user-alarm-accident.component';
import { AddFavorisReportComponent } from './add-favoris-report/add-favoris-report.component';
import { PlannificationReportComponent } from './plannification-report/plannification-report.component';
import { ReportHistoryComponent } from './report-history/report-history.component';
import { ReportComponent } from './report/report.component';
import { UserAlarmEventsComponent } from './user-alarm-events/user-alarm-events.component';
import {UserCoreContainerComponent } from './user-core/user-core-container/user-core-container.component';
import { UserVehiculeDetComponent } from './user-vehicle/user-vehicule-details/user-vehicule-det/user-vehicule-det.component';
import { UserVehiculeDetailsContainerComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-container/user-vehicule-details-container.component';
import { UserVehiculeDetailsEventsComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-events/user-vehicule-details-events.component';
import { UserVehiculeDetailsScoresComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-scores/user-vehicule-details-scores.component';
import { UserVehiculeComponent } from './user-vehicle/user-vehicule/user-vehicule.component';
import { AuthGuard } from '../_helpers';
import { Role } from '../_models';
import { UserAlarmComponent } from './user-alarm/user-alarm.component';
import { UserConducteurComponent } from './user-conducteur/user-conducteur/user-conducteur.component';
import { UserConducteurDetailsComponent } from './user-conducteur/user-conducteur-details/user-conducteur-details.component';
import { EventsComponent } from './events/events/events.component';
import { EventsDetailsComponent } from './events/events-details/events-details.component';
 
import { ContactComponent } from './contact/contact.component';
import { HistoriqueAlarmComponent } from './historique-alarm/historique-alarm.component';
import { UserConducteurTrajetComponent } from './user-conducteur/user-conducteur-trajet/user-conducteur-trajet.component';
import { DownloadRapportComponent } from './download-rapport/download-rapport.component';
// import { UserListconducteurComponent } from './user-conducteur/user-listconducteur/user-listconducteur.component';
import { DriverComponent } from '../driver/driver.component';
import { VehicleComponent } from '../vehicle/vehicle.component';

const routes: Routes = [
  {path:"" , component:UserCoreContainerComponent  , children:[
    {path:"vehicule" , component:  UserVehiculeComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    {path: 'profil' , component: ProfilComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'alarm/events', component: UserAlarmEventsComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'alarm/accident', component: UserAlarmAccidentComponent, canActivate: [AuthGuard],data: { roles: [Role.User]} },
    { path: 'report', component: ReportComponent, canActivate: [AuthGuard],data: { roles: [Role.User]} },
    { path:'reportfavorite', component: AddFavorisReportComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'plannification', component:PlannificationReportComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path:'reportHistory', component:ReportHistoryComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},

    { path: 'vehicule/details/:id', component: UserVehiculeDetailsEventsComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'userVehiculeScores', component: UserVehiculeDetailsScoresComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: ':id/trajet/:id', component: UserVehiculeDetComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'alarm', component: UserAlarmComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'conducteur', component: UserConducteurComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    // { path: 'driverlistconducteur', component: UserListconducteurComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    {path: 'driverlistconducteur' , component: DriverComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    {path: 'listvehicule' , component: VehicleComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},

    { path: 'conducteur/details/:id', component: UserConducteurDetailsComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'conducteur/trajet/:id', component: UserConducteurTrajetComponent, canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'events', component: EventsComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'events/details', component: EventsDetailsComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'contacts', component: ContactComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'alarms/history', component: HistoriqueAlarmComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    { path: 'report/download', component: DownloadRapportComponent , canActivate: [AuthGuard],data: { roles: [Role.User]}},
    


  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserSideRoutingModule { }
